import React, { useEffect, useRef, useState } from "react";
import { SecurityPageProps } from "models/security";
import { useHistory } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/app/hooks";

import { addConfirmarSenhaUnlockCartao } from "redux/features/cartao/desbloqueio-slice";
import ContainerFlex from "components/ContainerFlex";
import KeyboardWrapper from "components/Keyboard";
import Input from "components/input";

import * as St from "./styles";
import { showMessage } from "utils/messages";
import { RouteNames } from "routes/routes";

const ClienteConfirmarSenha: React.FC<SecurityPageProps> = ({
  title,
  subDescription,
  description,
  nextStep,
  backStep,
}) => {
  const [input, setInput] = useState("");
  const [value, setValue] = useState("");

  const keyboard = useRef(null);
  const history = useHistory();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (input.length <= 6) {
      setValue(input);
    }
  }, [input]);

  const {
    cartao: { criarSenha },
  } = useAppSelector((state) => state.cartaoDesbloqueio);

  const handleSubmit = async () => {
    dispatch(addConfirmarSenhaUnlockCartao(value));
    const senha = value || "";
    if (senha.length > 6) {
      showMessage("warning", "Atenção!", "A senha deve conter 6 dígitos", {
        timer: 9000,
        showConfirmButton: false,
      });
    } else {
      if (value === criarSenha) {
        const propsRouter: SecurityPageProps = {
          nextStep: RouteNames.ATENDIMENTO_LIMITE,
          backStep: RouteNames.HOME,
          fluxoUnlock: true,
        };

        history.push({
          pathname: RouteNames.UNLOCK_CLIENTE_PUSH_SMS,
          state: { ...propsRouter },
        });
      } else {
        showMessage(
          "warning",
          "Confirmação de senha!",
          "Senhas digitadas não conferem, tente novamente!",
          { timer: 3500, showConfirmButton: false }
        );
      }
    }
  };

  const clickToBack = () => {
    history.push(backStep);
  };

  return (
    <ContainerFlex center flex={1} horizontal>
      <ContainerFlex center>
        <St.Title>Desbloqueio</St.Title>
      </ContainerFlex>

      <ContainerFlex center>
        <St.Description>
          <span>
            Agora vamos confirmar a senha do TeuCard. Favor digitar a mesma
            senha de 6 dígitos criada anteriormente e pressione a tecla verde
            (ENTRA), para continuar a operação:
          </span>
        </St.Description>
      </ContainerFlex>
      <ContainerFlex center>
        <ContainerFlex width={60}>
          <ContainerFlex marginBottom={10}>
            <Input
              name="password"
              id="password"
              type="password"
              label="Valor"
              style={{
                height: "15%",
                textAlign: "center",
                fontSize: "20px",
                fontWeight: "bold",
              }}
              value={value}
              maxLength={6}
              onChange={(e) => setValue(e)}
              edit
              disabled
            />
          </ContainerFlex>
          <KeyboardWrapper
            onPressBack={clickToBack}
            keyboardRef={keyboard}
            onChange={setInput}
            typeKeyboard="numeric"
            onPressEnter={() => handleSubmit()}
          />
        </ContainerFlex>
      </ContainerFlex>
    </ContainerFlex>
  );
};

export default ClienteConfirmarSenha;
